import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function scrollToSection(href, behavior) {
  const el = document.querySelector(href);
  if (!el) return false;
  const headerH = document.querySelector("[data-testid='site-header']")?.offsetHeight || 64;
  const top = el.getBoundingClientRect().top + window.scrollY - headerH;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: Math.max(0, top), behavior: behavior || (reduce ? "instant" : "smooth") });
  return true;
}

/* Navigate to a homepage section (#id) from any page, or to a route (/butikk). */
export function useSectionNav() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback((href) => {
    if (!href.startsWith("#")) { navigate(href); window.scrollTo({ top: 0, behavior: "instant" }); return; }
    if (location.pathname === "/") {
      requestAnimationFrame(() => scrollToSection(href));
    } else {
      navigate({ pathname: "/", hash: href });
    }
  }, [navigate, location.pathname]);
}
